import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import PorteBlindee from "./pages/PorteBlindee";
import OuverturePorte from "./pages/OuverturePorte";
import RemplacementSerrure from "./pages/RemplacementSerrure";
import DepannagePorte from "./pages/DepannagePorte";
import DepannageCoffreFort from "./pages/DepannageCoffreFort";
import Devis from "./pages/Devis";
import Simulateur from "./pages/Simulateur";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/porte-blindee" element={<PorteBlindee />} />
            <Route path="/ouverture-porte" element={<OuverturePorte />} />
            <Route path="/remplacement-serrure" element={<RemplacementSerrure />} />
            <Route path="/depannage-porte" element={<DepannagePorte />} />
            <Route path="/depannage-coffre-fort" element={<DepannageCoffreFort />} />
            <Route path="/devis" element={<Devis />} />
            <Route path="/simulateur" element={<Simulateur />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
